export default {
    showModal: state => state.step,
  }